import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textField"]
  static values = { checkboxId: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const checkbox = document.getElementById(this.checkboxIdValue)
    if (checkbox && checkbox.checked) {
      this.textFieldTarget.classList.remove("d-none")
    } else {
      this.textFieldTarget.classList.add("d-none")
    }
  }
}
